<template>
  <div>
    <el-tooltip placement="right">
      <div slot="content" class="max-w-sm max-h-500p overflow-auto">
        <div v-if="(!(content instanceof Array))"><span>{{ content }}</span></div>
        <div v-else>
          <span v-for="line in content" :key="line.key">{{ line }}<br /></span>
        </div>
      </div>
      <span class="tooltip-icon-multiple__icon-wrap">
        <base-icon :size="size" name="info" class="w-10/5 h-10/5 cbutton--prim-phantom bg-primary-50 dark:bg-darkblue text-primary hover:text-primary-500 dark:hover:text-white hover:bg-primary-100 dark:hover:bg-primary-500 rounded-full" />
      </span>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'tooltip-icon-multiple',
  props: {
    content: {
      type: Array,
      default: () => ['info']
    },
    size: {
      type: String,
      default: 'md'
    },
  },
}
</script>
